import React from 'react';
import styles from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  confirmText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, title, children, confirmText, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} data-testid="confirmation-modal">
        <div className={styles.iconWrapper}>!</div>
        <h2 className={styles.title} data-testid="confirmation-modal-title">{title}</h2>
        <p className={styles.message} data-testid="confirmation-modal-message">{children}</p>
        <div className={styles.footer}>
          <button className={`${styles.button} ${styles.cancelButton}`} onClick={onCancel} data-testid="confirmation-modal-cancel">
            Cancel
          </button>
          <button className={`${styles.button} ${styles.confirmButton}`} onClick={onConfirm} data-testid="confirmation-modal-confirm">
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
